import axios from "axios";
import React, { Component } from "react";
import {
	Button /*, OverlayTrigger, Tooltip*/,
	Modal,
	OverlayTrigger,
	Tooltip,
} from "react-bootstrap";
import { connect } from "react-redux";
//!!!r-18-bk
//@ts-expect-error
import { withRouter } from "react-router";
import type { AppState } from "../../../store";
import {
	updateFavorites,
	updateSavedFilters,
} from "../../../store/user/actions";
import AxiosConfig from "../../../utilities/AxiosConfig";
import Dialog from "../../../utilities/Dialog";
import VehicleGeneralSearch from "./GeneralSearch/VehicleGeneralSearch";
import VasInspections from "./VASInspections/VasInspections";
import VasLeft from "./VASLeft/VasLeft";
import VasMaintenance from "./VASMaintenenance/VasMaintenenance";
import VasMiles from "./VASRanges/VasMiles/VasMiles";
import VasRanges from "./VASRanges/VasRanges";
import VasYears from "./VASRanges/VasYears/VasYears";
import VasRight from "./VASRight/VasRight";
import "./VehicleAdvancedSearch.css";
import VasLeaseTracking from "./VASLeaseTracking/VasLeaseTracking";

interface VehicleAdvancedSearchProps {
	toggleAdvancedSearch: Function;
	advancedSearch: boolean;
	getVehicles: Function;
	updateFavorites: any;
	updateSavedFilters: any;
	match: any;
	search: any;
	location: any;
	history: any;
	fleetReference: any;
	features: { [key: string]: boolean };
}

type VehicleAdvancedSearchTypes = {
	input: string;
	generalSearchPlaceholder: string;
	hasParams: boolean;
	PurchaseDate: boolean;
	RegistrationExpiration: boolean;
	LeaseExpiration: boolean;
	DispositionDate: boolean;
	HasUnreviewedInspections: boolean;
	HasApproved: boolean;
	Rejected: boolean;
	HasOverdueMaintenance: boolean;
	activeParams: number;
	vehicleDrivers: Array<string>;
	vehicleMakes: Array<string>;
	vehicleModels: Array<string>;
	vehicleStatusTypes: Array<string>;
	vehicleStateTypes: Array<string>;
	vehicleProfitCenters: Array<string>;
	lastDriver: string;
	selectedMake: string;
	selectedModel: string;
	selectedStatus: string;
	selectedDriver: string;
	selectedState: string;
	selectedArea: string;
	MaintenanceNum: string;
	HasUnreviewedMaintenances: boolean;
	isChrome: boolean;
	showRegistration: boolean;
	showMileRange: boolean;
	showYearRange: boolean;
	showSpecific: boolean;
	showInspections: boolean;
	showMaintenance: boolean;
	showLeaseTracking: boolean;
	HasActiveLease: boolean;
	HasLeaseRecords: boolean;
};

class VehicleAdvancedSearch extends Component<
	VehicleAdvancedSearchProps,
	VehicleAdvancedSearchTypes
> {
	searchParams: any = {
		GeneralTerm: "",
		StartDate: "",
		StartDateUtcts: "",
		EndDateUtcts: "",
		EndDate: "",
		DateRangeType: "",
		StartMileage: "",
		EndMileage: "",
		StartYear: "",
		EndYear: "",
		VehicleStatusTypeId: "",
		VehicleMakeId: "",
		VehicleModelId: "",
		DriverId: "",
		VinNumber: "",
		LicenseNumber: "",
		LeaseNumber: "",
		RegistrationNumber: "",
		VehicleNumber: "",
		StateId: "",
		ProfitCenterId: "",
		PurchasedFrom: "",
		HasUnreviewedInspections: "",
		HasApproved: "",
		MaintenanceNum: "",
		Rejected: "",
		HasOverdueMaintenance: "",
		HasUnreviewedMaintenances: "",
		Area: "",
		TitleNumber: "",
		HasActiveLease: "",
		HasLeaseRecords: "",
		UnitNumber: "",
	};

	wrapperRef: any;
	awaitFleet: any;
	favUrl = "";

	constructor(props: any) {
		super(props);
		this.state = {
			input: "",
			generalSearchPlaceholder:
				"Vehicle Number, Decal Id, Last Driver or Vin Number",
			hasParams: false,
			PurchaseDate: false,
			RegistrationExpiration: false,
			LeaseExpiration: false,
			DispositionDate: false,
			HasUnreviewedInspections: false,
			HasUnreviewedMaintenances: false,
			HasApproved: false,
			Rejected: false,
			HasOverdueMaintenance: false,
			activeParams: 0,
			vehicleDrivers: [],
			vehicleMakes: [],
			vehicleModels: [],
			vehicleStatusTypes: [],
			vehicleStateTypes: [],
			vehicleProfitCenters: [],
			lastDriver: "--Last Driver--",
			selectedMake: "--Select Make--",
			selectedModel: "--Select Model--",
			selectedStatus: "In Use",
			selectedDriver: "--Select Driver--",
			selectedState: "--Select State--",
			selectedArea: "--Select Location--",
			MaintenanceNum: "",
			isChrome: true,
			showRegistration: false,
			showMileRange: true,
			showYearRange: true,
			showSpecific: true,
			showInspections: true,
			showMaintenance: true,
			showLeaseTracking: true,
			HasActiveLease: false,
			HasLeaseRecords: false,
		};
		this.wrapperRef = React.createRef();
		this.handleChange = this.handleChange.bind(this);
		// this.handleClickOutside = this.handleClickOutside.bind(this);
		this.handleKeyStroke = this.handleKeyStroke.bind(this);
	}

	componentDidMount() {
		// this.getFleetReference()
		this.awaitFleet = setInterval(this.awaitFleetReference, 100);
		document.addEventListener("keyup", this.handleKeyStroke);
		// document.addEventListener("click", this.handleClickOutside)
		this.getBrowserType();
		this.appendParams([{ VehicleStatusTypeId: "1" }]);
	}

	awaitFleetReference = () => {
		if (this.props.fleetReference.lastDrivers) {
			clearInterval(this.awaitFleet);
			this.setState({
				vehicleMakes: this.props.fleetReference.vehicleMakes.sort(
					(a: any, b: any) => (a.text > b.text ? 1 : -1),
				),
				vehicleModels: this.state.vehicleModels.sort((a: any, b: any) =>
					a.text > b.text ? 1 : -1,
				),
				vehicleDrivers: this.props.fleetReference.lastDrivers.sort(
					(a: any, b: any) => (a.text > b.text ? 1 : -1),
				),
				vehicleStatusTypes: this.props.fleetReference.vehicleStatusTypes.sort(
					(a: any, b: any) => (a.text > b.text ? 1 : -1),
				),
				vehicleStateTypes: this.props.fleetReference.states.sort(
					(a: any, b: any) => (a.text > b.text ? 1 : -1),
				),
				vehicleProfitCenters: this.props.fleetReference.profitCenters.sort(
					(a: any, b: any) => (a.text > b.text ? 1 : -1),
				),
			});
		}
	};

	componentWillUnmount() {
		document.removeEventListener("keyup", this.handleKeyStroke);
		clearInterval(this.awaitFleet);
	}

	getBrowserType = () => {
		if (navigator.userAgent.indexOf("Firefox") !== -1) {
			this.setState({ isChrome: false });
		}
	};

	componentDidUpdate() {
		// this.handleFav()
	}

	handleClickOutside = (_event: { target: any }) => {
		// if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
		//     this.props.toggleAdvancedSearch("off")
		// }
	};

	getModels = (modelId: number) => {
		axios
			.get(
				`${process.env.REACT_APP_API_URL}/api/Fleet/getVehicleModelsByMake/${modelId}`,
				AxiosConfig.configValue(),
			)
			.then((res) => {
				const models: any = res.data.vehicleModels.sort((a: any, b: any) =>
					a.text > b.text ? 1 : -1,
				);
				this.setState({ vehicleModels: models });
				//console.log(res)
			})
			.catch((_err) => {
				//console.log(err)
			});
	};

	appendParams = (param: Array<object>) => {
		//r-18-lint-bk
		//eslint-disable-next-line
		for (const [key, _value] of Object.entries(this.searchParams)) {
			for (let i = 0; i < param.length; i++) {
				const paramKey = Object.keys(param[i]);
				if (key === paramKey[0]) {
					const searchTearm = Object.values(param[i]);
					this.searchParams[paramKey[0]] = `${searchTearm[0]}`;
				}
			}
		}
		if (this.submitCheck(this.searchParams)) {
			this.setState({ hasParams: true });
		} else {
			this.setState({ hasParams: false });
		}
	};

	submitCheck = (params: Object) => {
		const arr = [];
		for (const [key, value] of Object.entries(params)) {
			if (value.length > 0 && key !== "StartDate" && key !== "EndDate") {
				arr.push(value);
			}
		}
		if (arr.length > 0) {
			this.setState({ activeParams: arr.length });
			return true;
		} else {
			this.setState({ activeParams: arr.length });
			return false;
		}
	};

	handleSubmit = () => {
		if (this.state.input === "") {
			this.props.getVehicles(this.searchParams);
			this.props.toggleAdvancedSearch();
		} else {
			this.props.getVehicles({ GeneralTerm: this.state.input });
			this.props.toggleAdvancedSearch();
		}
	};

	toggleSelections = (types: Array<string>) => {
		for (let i = 0; i < types.length; i++) {
			const str = types[i].split("-");
			if (str[1] === "t") {
				const obj: object = { [str[0]]: true };
				const param: object = { [str[0]]: "true" };
				this.setState(obj);
				this.appendParams([param]);
			} else {
				const obj: object = { [str[0]]: false };
				const param: object = { [str[0]]: "" };
				this.setState(obj);
				this.appendParams([param]);
			}
		}
	};

	setModel = (param: Array<any>, placeHolderText: string) => {
		this.setState({ selectedModel: placeHolderText });
		this.appendParams(param);
	};

	setMake = (param: Array<any>, placeHolderText: string) => {
		this.setState({ selectedMake: placeHolderText });
		this.appendParams(param);
		if (param[0].VehicleMakeId !== "") {
			this.getModels(param[0].VehicleMakeId);
		} else {
			this.setModel([{ VehicleModelId: "" }], "--Select Model--");
			this.setState({ vehicleModels: [] });
		}
	};

	setVehicleStatus = (param: Array<object>, placeHolderText: string) => {
		this.setState({ selectedStatus: placeHolderText });
		this.appendParams(param);
	};

	setMaintenanceNumber = (param: Array<object>, placeHolderText: string) => {
		this.setState({ MaintenanceNum: placeHolderText });
		this.appendParams(param);
	};

	setDriver = (param: Array<object>, placeHolderText: string) => {
		this.setState({ lastDriver: placeHolderText });
		this.appendParams(param);
	};

	setTheState = (param: Array<any>, placeHolderText: string) => {
		this.setArea([{ ProfitCenterId: "" }], "--Select Location--");
		this.setState({ selectedState: placeHolderText });
		this.appendParams(param);
		this.filterAreas(param[0].StateId);
	};

	setArea = (param: Array<object>, placeHolderText: string) => {
		this.setState({ selectedArea: placeHolderText });
		this.appendParams(param);
	};

	filterAreas = (filter: string) => {
		if (filter === "") {
			this.setState({
				vehicleProfitCenters: this.props.fleetReference.profitCenters.sort(
					(a: any, b: any) => (a.text > b.text ? 1 : -1),
				),
			});
		} else {
			axios
				.get(
					`${process.env.REACT_APP_API_URL}/api/Fleet/GetProfitCentersByStateId/${filter}`,
					AxiosConfig.configValue(),
				)
				.then((res) => {
					this.setState({
						vehicleProfitCenters: res.data.profitCenters.sort(
							(a: any, b: any) => (a.text > b.text ? 1 : -1),
						),
					});
				})
				.catch((_err) => {
					//console.log(err)
				});
		}
	};

	clearInput = () => {
		this.setState({ input: "" });
		this.appendParams([{ GeneralTerm: "" }]);
	};

	clearForm = () => {
		const vasRangesClear = document.getElementById("vas-ranges-clear");
		if (vasRangesClear) {
			vasRangesClear.click();
		}

		const vasClearStartDate = document.getElementById("vas-date-start");
		if (vasClearStartDate) {
			vasClearStartDate.click();
		}

		const vasClearEndDate = document.getElementById("vas-date-end");
		if (vasClearEndDate) {
			vasClearEndDate.click();
		}

		const vasInspectionsChecked = document.getElementById("vas-ranges-checked");
		if (vasInspectionsChecked) {
			vasInspectionsChecked.click();
		}

		const vasUnreviewedMaintenenanceChecked = document.getElementById(
			"vas-unreviewed-maintenance-checked",
		);
		if (vasUnreviewedMaintenenanceChecked) {
			vasUnreviewedMaintenenanceChecked.click();
		}

		const vasOverdueMaintenenanceChecked = document.getElementById(
			"vas-overdue-maintenance-checked",
		);
		if (vasOverdueMaintenenanceChecked) {
			vasOverdueMaintenenanceChecked.click();
		}

		const clickInterval = setInterval(clickTimer, 100);

		function clickTimer() {
			const vasLeftClearStatus = document.getElementById("vas-clear-x-btn");
			if (vasLeftClearStatus) {
				vasLeftClearStatus.click();
			} else {
				stopClick();
			}
		}

		function stopClick() {
			clearInterval(clickInterval);
		}
		this.setState({ input: "" });
		//r-18-lint-bk
		//eslint-disable-next-line
		this.appendParams([{ GeneralTerm: "" }, { UnitNumber: "" }]);
	};

	handleChange = (event: { target: { value: any } }) => {
		this.setState({ input: event.target.value });
		//r-18-lint-bk
		//eslint-disable-next-line
		this.appendParams([{ GeneralTerm: event.target.value }]);
	};

	handleKeyStroke = (event: { target: any; key: any }) => {
		if (this.props.advancedSearch) {
			if (event.key === "Enter" && this.state.hasParams) {
				this.handleSubmit();
			}
		}
	};

	addFavorite = async () => {
		const prompt: any = new Dialog({
			type: "prompt",
			message: "Filter Name: ",
			trueText: "Submit",
			falseText: "Cancel",
		});
		const answer: string = await prompt.show();
		const params = Object.entries(this.searchParams);
		let url = "/fleet/?";
		for (let i = 0; i < params.length; i++) {
			if (params[i][1] !== "") {
				url += `&${params[i][0]}=${params[i][1]}`;
			}
		}
		if (answer) {
			this.props.updateFavorites({
				url: url,
				name: answer,
				category: "Fleet",
				hasFilter: true,
			});
			this.props.updateSavedFilters("Fleet", answer, this.searchParams, false);
		}
	};

	handleFav = () => {
		if (this.favUrl !== window.location.href) {
			const location = window.location.href.split("&");
			const param: any = {};
			const params = [];
			if (location.length > 1) {
				for (let i = 1; i < location.length; i++) {
					const temp = location[i].split("=");
					param[temp[0]] = temp[1];
					const obj: object = { [temp[0]]: temp[1] };
					params.push(obj);
				}
				this.props.getVehicles(param);
				this.prepopulate(params);
				this.favUrl = window.location.href;
			}
		}
	};

	prepopulate = (params: Array<any>) => {
		this.setState({
			lastDriver: "--Last Driver--",
			selectedMake: "--Select Make--",
			selectedModel: "--Select Model--",
			selectedStatus: "--Vehicle Status--",
			selectedDriver: "--Select Driver--",
			selectedState: "--Select State--",
			selectedArea: "--Select Location--",
		});

		Object.keys(this.searchParams).forEach((key) => {
			this.searchParams[key] = "";
		});

		this.appendParams(params);

		if (this.searchParams.VehicleStatusTypeId !== "") {
			for (
				let i = 0;
				i < this.props.fleetReference.vehicleStatusTypes.length;
				i++
			) {
				if (
					this.searchParams.VehicleStatusTypeId ===
					`${this.props.fleetReference.vehicleStatusTypes[i].id}`
				) {
					this.setVehicleStatus(
						[{ VehicleStatusTypeId: this.searchParams.VehicleStatusTypeId }],
						this.props.fleetReference.vehicleStatusTypes[i].text,
					);
				}
			}
		}

		if (this.searchParams.VehicleMakeId !== "") {
			for (let i = 0; i < this.props.fleetReference.vehicleMakes.length; i++) {
				if (
					this.searchParams.VehicleMakeId ===
					`${this.props.fleetReference.vehicleMakes[i].id}`
				) {
					this.setMake(
						[{ VehicleMakeId: this.searchParams.VehicleMakeId }],
						this.props.fleetReference.vehicleMakes[i].text,
					);
				}
			}
		}

		if (this.searchParams.VehicleModelId !== "") {
			for (let i = 0; i < this.props.fleetReference.vehicleMakes.length; i++) {
				if (
					this.searchParams.VehicleModelId ===
					`${this.props.fleetReference.vehicleModels[i].id}`
				) {
					this.setModel(
						[{ VehicleModelId: this.searchParams.VehicleModelId }],
						this.props.fleetReference.vehicleModels[i].text,
					);
				}
			}
		}

		if (this.searchParams.DriverId !== "") {
			for (let i = 0; i < this.props.fleetReference.lastDrivers.length; i++) {
				if (
					this.searchParams.DriverId ===
					`${this.props.fleetReference.lastDrivers[i].id}`
				) {
					this.setDriver(
						[{ DriverId: this.searchParams.DriverId }],
						this.props.fleetReference.lastDrivers[i].text,
					);
				}
			}
		}

		if (this.searchParams.StateId !== "") {
			for (let i = 0; i < this.props.fleetReference.states.length; i++) {
				if (
					this.searchParams.StateId ===
					`${this.props.fleetReference.states[i].id}`
				) {
					this.setTheState(
						[{ StateId: this.searchParams.StateId }],
						this.props.fleetReference.states[i].text,
					);
				}
			}
		}

		if (this.searchParams.ProfitCenterId !== "") {
			for (let i = 0; i < this.props.fleetReference.profitCenters.length; i++) {
				if (
					this.searchParams.ProfitCenterId ===
					`${this.props.fleetReference.profitCenters[i].id}`
				) {
					this.setArea(
						[{ ProfitCenterId: this.searchParams.ProfitCenterId }],
						this.props.fleetReference.profitCenters[i].text,
					);
				}
			}
		}
	};

	toggleSection = (key: string) => {
		const temp: any = this.state;
		if (temp[key]) {
			temp[key] = false;
		} else {
			temp[key] = true;
		}
		this.setState(temp);
	};

	render() {
		// //console.log(this.searchParams)
		// //console.log(this.props)

		// const favTooltip = (
		//     <Tooltip id="vt-pin-tooltip">
		//         Add to Favorites
		//     </Tooltip>
		// )

		const applyFieldsTooltip = (
			<Tooltip id="employees-pin-tooltip">Apply filters</Tooltip>
		);

		return (
			<div className="VehicleAdvancedSearch" ref={this.wrapperRef}>
				<OverlayTrigger
					trigger={["hover", "focus"]}
					placement="right"
					overlay={applyFieldsTooltip}
				>
					<div className="VASMenuBtn">
						<div
							id="vas-dropdown-btn"
							onClick={() => this.props.toggleAdvancedSearch()}
						>
							{/* {this.state.input === "" && <p>Search Options {"(" + this.state.activeParams + " Active)"}</p>}
                        {this.state.input !== "" && <p>{this.state.generalSearchPlaceholder}</p>} */}
							<span className="material-icons">filter_alt</span>
							{this.state.activeParams > 0 && (
								<p>Applied Filters ({this.state.activeParams})</p>
							)}
						</div>
					</div>
				</OverlayTrigger>

				{this.props.advancedSearch && (
					<Modal show={true} backdrop="static" keyboard={true}>
						<div className="VASDropdown">
							<div className="GeneralSearchWrapper">
								<VehicleGeneralSearch
									input={this.state.input}
									placeholder={this.state.generalSearchPlaceholder}
									handleChange={this.handleChange}
									clearInput={this.clearInput}
									handSubmit={this.handleSubmit}
								/>
							</div>
							{this.state.input === "" && (
								<div id="vas-lower">
									<div className="VASDropdownR1">
										<div
											id="vas-ranges-header"
											onClick={() => this.toggleSection("showRegistration")}
										>
											<p>Registration Ranges</p>
											<div className="VASDropdownCarrat">
												{!this.state.showRegistration && (
													<span className="material-icons">expand_more</span>
												)}
												{this.state.showRegistration && (
													<span className="material-icons">expand_less</span>
												)}
											</div>
										</div>
										{this.state.showRegistration && (
											<VasRanges
												searchParams={this.searchParams}
												toggleSelections={this.toggleSelections}
												appendParams={this.appendParams}
												PurchaseDate={this.state.PurchaseDate}
												RegistrationExpiration={
													this.state.RegistrationExpiration
												}
												LeaseExpiration={this.state.LeaseExpiration}
												DispositionDate={this.state.DispositionDate}
												isChrome={this.state.isChrome}
											/>
										)}
										<div
											id="vas-miles-header"
											onClick={() => this.toggleSection("showMileRange")}
										>
											<p>Mileage Ranges</p>
											<div className="VASDropdownCarrat">
												{!this.state.showMileRange && (
													<span className="material-icons">expand_more</span>
												)}
												{this.state.showMileRange && (
													<span className="material-icons">expand_less</span>
												)}
											</div>
										</div>
										{this.state.showMileRange && (
											<VasMiles
												appendParams={this.appendParams}
												searchParams={this.searchParams}
											/>
										)}
										<div
											id="vas-years-header"
											onClick={() => this.toggleSection("showYearRange")}
										>
											<p>Year Ranges</p>
											<div className="VASDropdownCarrat">
												{!this.state.showYearRange && (
													<span className="material-icons">expand_more</span>
												)}
												{this.state.showYearRange && (
													<span className="material-icons">expand_less</span>
												)}
											</div>
										</div>
										{this.state.showYearRange && (
											<VasYears
												appendParams={this.appendParams}
												searchParams={this.searchParams}
											/>
										)}
									</div>
									<div className="VASDropdownR2">
										<div className="Vas-Specific-Wrapper">
											<div
												id="vas-specific-header"
												onClick={() => this.toggleSection("showSpecific")}
											>
												<p>Specific Fields</p>
												<div className="VASDropdownCarrat">
													{!this.state.showSpecific && (
														<span className="material-icons">expand_more</span>
													)}
													{this.state.showSpecific && (
														<span className="material-icons">expand_less</span>
													)}
												</div>
											</div>
											{this.state.showSpecific && (
												<div className="VasLeftRightWrapper">
													<VasLeft
														searchParams={this.searchParams}
														vehicleMakes={this.state.vehicleMakes}
														vehicleModels={this.state.vehicleModels}
														vehicleDrivers={this.state.vehicleDrivers}
														vehicleStatusTypes={this.state.vehicleStatusTypes}
														vehicleStates={this.state.vehicleStateTypes}
														profitCenters={this.state.vehicleProfitCenters}
														lastDriver={this.state.lastDriver}
														selectedMake={this.state.selectedMake}
														selectedModel={this.state.selectedModel}
														selectedStatus={this.state.selectedStatus}
														selectedState={this.state.selectedState}
														selectedArea={this.state.selectedArea}
														MaintenanceNum={this.state.MaintenanceNum}
														setModel={this.setModel}
														setMake={this.setMake}
														setVehicleStatus={this.setVehicleStatus}
														setMaintenanceNumber={this.setMaintenanceNumber}
														setDriver={this.setDriver}
														setTheState={this.setTheState}
														setArea={this.setArea}
														appendParams={this.appendParams}
													/>
													<VasRight
														appendParams={this.appendParams}
														searchParams={this.searchParams}
													/>
												</div>
											)}
										</div>
									</div>
									<div className="VASDropdownR3">
										<div
											id="vas-inspections-header"
											onClick={() => this.toggleSection("showInspections")}
										>
											<p>Inspections</p>
											<div className="VASDropdownCarrat">
												{!this.state.showInspections && (
													<span className="material-icons">expand_more</span>
												)}
												{this.state.showInspections && (
													<span className="material-icons">expand_less</span>
												)}
											</div>
										</div>
										{this.state.showInspections && (
											<VasInspections
												toggleSelections={this.toggleSelections}
												waitingReview={this.state.HasUnreviewedInspections}
												isChrome={this.state.isChrome}
											/>
										)}
										<div
											id="vas-maintenance-header"
											onClick={() => this.toggleSection("showMaintenance")}
										>
											<p>Maintenance</p>
											<div className="VASDropdownCarrat">
												{!this.state.showMaintenance && (
													<span className="material-icons">expand_more</span>
												)}
												{this.state.showMaintenance && (
													<span className="material-icons">expand_less</span>
												)}
											</div>
										</div>
										{this.state.showMaintenance && (
											<VasMaintenance
												toggleSelections={this.toggleSelections}
												waitingReview={this.state.HasUnreviewedInspections}
												HasUnreviewedMaintenances={
													this.state.HasUnreviewedMaintenances
												}
												HasOverdueMaintenance={this.state.HasOverdueMaintenance}
												isChrome={this.state.isChrome}
											/>
										)}
										{this.props.features?.LeaseTracker && (
											<>
												<div
													id="vas-lease-tracking-header"
													onClick={() =>
														this.toggleSection("showLeaseTracking")
													}
												>
													<p>Lease Tracking</p>
													<div className="VASDropdownCarrat">
														{!this.state.showLeaseTracking && (
															<span className="material-icons">expand_more</span>
														)}
														{this.state.showLeaseTracking && (
															<span className="material-icons">expand_less</span>
														)}
													</div>
												</div>
												{this.state.showLeaseTracking && (
													<VasLeaseTracking
														toggleSelections={this.toggleSelections}
														appendParams={this.appendParams}
														hasActiveLease={this.state.HasActiveLease}
														hasLeaseRecords={this.state.HasLeaseRecords}
														isChrome={this.state.isChrome}
														searchParams={this.searchParams}
													/>
												)}
											</>
										)}
										{this.state.hasParams && (
											<Button id="vas-clear-all-btn" onClick={this.clearForm}>
												Clear
											</Button>
										)}
										{this.state.hasParams && (
											<Button id="vas-submit-btn" onClick={this.handleSubmit}>
												Submit
											</Button>
										)}
										{/* {this.state.hasParams &&
                            <OverlayTrigger trigger={["hover", "focus"]} placement="right" overlay={favTooltip}>
                                <p id="vas-add-to-favorites-btn"><span className="material-icons" onClick={this.addFavorite}>favorite</span></p>
                            </OverlayTrigger>} */}
										{!this.state.hasParams && (
											<div className="VASall">
												<Button
													id="vas-all-btn"
													onClick={() => this.props.getVehicles({})}
												>
													All Vehicles
												</Button>
											</div>
										)}
									</div>
								</div>
							)}
							<div
								className="CloseAdvancedSearchBtn"
								onClick={() => this.props.toggleAdvancedSearch()}
							>
								<span className="material-icons">close</span>
							</div>
						</div>
					</Modal>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state: AppState) => ({ features: state.features });
const wr: any = withRouter(VehicleAdvancedSearch);
export default connect(mapStateToProps, {
	updateFavorites,
	updateSavedFilters,
})(wr) as any;
